<template>
	<div class="customerBilling">
		<div class="customerBillingTitle">
			Billing
		</div>
		<div class="safetyWrapper">
			<div class="groupFields">
				<field
						:class-error="getError('billing_rate_driver')"
						margin="10px 0 0"
						width="120px"
						type="number"
						label="Rate amount"
						placeholder="0"
						:setInputValue="billing_rate_driver"
						@updateInput="onRateInput"
						is-required
				></field>
				<field
						margin="10px 0 0 10px"
						width="270px"
						label="Sale manager"
						placeholder="Employee"
						@updateAutocomplete="onManagerAutocomplete($event, 'creator')"
						:autocompleteValue="creator"
						:items="dispatchersList"
						is-autocomplete
				></field>
			</div>
			<div class="groupField">
				<div class="groupField_wrap">
					<field
							margin="10px 0 0 0"
							width="260px"
							label="Week start day"
							placeholder="Select week start day"
							@updateAutocomplete="onManagerAutocomplete($event, 'start_week')"
							:autocompleteValue="start_week"
							:items="getStartWeek"
							:is-clearable="false"
							is-autocomplete
					></field>
				</div>
			</div>
			<div class="groupFields">
				<div class="groupField">
					<div class="groupField_wrap">
						<field
								:class-error="getError('billing_email')"
								margin="10px 10px 0 0"
								width="260px"
								label="Billing email"
								placeholder="Enter billing email"
								@updateInput="onInput($event, 'billing_email')"
								:setInputValue="billing_email"
						></field>
						<field
								margin="10px 0 0 0"
								width="260px"
								type="number"
								label="Billing phone"
								placeholder="Enter billing phone"
								@updateInput="onInput($event, 'billing_phone')"
								:setInputValue="billing_phone"
						></field>
					</div>
					<customer-requisites @updateRequisitesData="onRequisitesData"></customer-requisites>
				</div>
			</div>
			<factoring
					:factoringSwitcher="factoringSwitcher"
					:valid="valid"
					:factoring_id="factoring_id"
          @updateFactoring="onFactoring"
			></factoring>
		</div>
	</div>
</template>

<script>
// vuex
import { mapGetters } from "vuex";
// components
import CustomerRequisites
from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Billing/CustomerRequisites/CustomerRequisites.vue";
import Factoring
from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Billing/Factoring/Factoring.vue";
// constants
import { START_WEEKS } from "@/components/Maintenance/Customer/CustomerForm/constants";

export default {
	name: "Billing",
	components: {
		CustomerRequisites,
		Factoring
	},
	props: {
		dispatchersList: Array,
		valid: Object,
		serviceList: Object,
		billing_rate_driver: [ Number, String ],
		factoring_id: Number,
		factoringSwitcher: Boolean
	},
	computed: {
		...mapGetters([ 'customersList' ]),
		getStartWeek() {
			return START_WEEKS;
		},
	},
	data: () => ({
		creator: null,
		start_week: null,
		billing_phone: null,
		billing_email: null,
		requisitesList: [],
		factoringList: [],
		factoring: false,
		driversList: []
	}),
	methods: {
		getError(key) {
			return this.valid[key] && this.valid[key].$error;
		},
		getData() {
			this.$emit('updateBillingData', { ...this.$data });
		},
		onRateInput({ value }) {
			this.$emit('updateBillingRate', { value: +value });
		},
		onInput({ value }, key) {
			this[key] = value;
			this.getData();
		},
		onDriversData(driversList) {
			this.driversList = driversList;
			this.getData();
		},
		onManagerAutocomplete({ value }, key) {
			this[key] = value;
			this.getData();
		},
		onRequisitesData(requisitesList) {
			this.requisitesList = requisitesList;
			this.getData();
		},
		onFactoring({ factoringList, isFactoring }) {
			this.factoringList = factoringList;
			this.factoring = isFactoring;
			this.getData();
		}
	},
	mounted() {
		const { customers } = this.customersList;
		const {
			billing_email,
			billing_phone,
			start_week
		} = customers;
		this.billing_email = billing_email;
		this.billing_phone = billing_phone;
		const { manager, manager_id } = this.serviceList;
		this.factoring = this.factoringSwitcher;
		this.creator = { value: manager, id: manager_id };

		this.start_week = this.getStartWeek.find(({ id }) => id === start_week) || { value: 'Monday', id: 1 };
	}
};
</script>

<style scoped lang="scss">
@import "Billing";
</style>
